import React from 'react';
import { ChevronRight, Trophy, Star, Users, Package, ShieldCheck, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToOferta = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const trustItems = [{
    icon: Star,
    label: 'Calificación 4.9/5'
  }, {
    icon: Users,
    label: '+800 alumnos'
  }, {
    icon: Package,
    label: '6 Tomos + 6 Bonos'
  }, {
    icon: ShieldCheck,
    label: 'Garantía 7 días'
  }, {
    icon: Zap,
    label: 'Acceso inmediato'
  }];
  return <section className="relative flex items-center pt-8 pb-12 overflow-hidden bg-navy-gradient" data-id="element-129">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10 mix-blend-overlay pointer-events-none" data-id="element-130"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-131">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-132">
          {/* Kicker badge */}
          <FadeIn data-id="element-133">
            <span className="inline-flex items-center gap-1.5 bg-celeste/10 border border-celeste/30 text-celeste font-display font-bold text-xs uppercase tracking-widest px-4 py-1.5 rounded-full mb-6" data-id="element-134">
              <Trophy className="w-3.5 h-3.5" data-id="element-135" /> Edición Mundialista 2026
            </span>
          </FadeIn>

          {/* Title */}
          <FadeIn data-id="element-136">
            <h1 className="font-display md:text-6xl lg:text-7xl font-black mb-2 uppercase text-white text-[24px]" data-id="element-137">
              JUGÁS CON LA ZURDA.
            </h1>
            <h2 className="font-display md:text-5xl lg:text-6xl font-bold italic text-celeste underline decoration-4 underline-offset-8 mb-8 text-[28px]" data-id="element-138">
              AHORA GANÁ CON ELLA.
            </h2>
          </FadeIn>

          {/* Product Mockup Image */}
          <FadeIn delay={0.2} direction="up" data-id="element-139">
            <div className="relative w-full max-w-2xl mx-auto mb-8" data-id="element-140">
              <div className="absolute inset-0 bg-celeste/20 blur-[100px] rounded-full" data-id="element-141"></div>
              <motion.img src="https://cdn.magicpatterns.com/uploads/x1fa9N91uHTBG96zBHijVv/Untitled_design_(1).png" alt="Zurdo Master Pack — Fútbol 5: 6 tomos y 6 bonos" className="relative z-10 w-full h-auto drop-shadow-2xl" animate={{
              y: [0, -10, 0]
            }} transition={{
              duration: 5,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-142" />
            </div>
          </FadeIn>

          {/* Subtitle */}
          <FadeIn delay={0.4} data-id="element-143">
            <p className="md:text-lg text-gray-300 mb-8 max-w-2xl mx-auto text-[14px]" data-id="element-144">
              El sistema completo que ya está ayudando a cientos de jugadores
              zurdos amateur a dominar la cancha de fútbol 5 con su pierna
              izquierda.
            </p>
          </FadeIn>

          {/* CTA */}
          <FadeIn delay={0.5} data-id="element-145">
            <Button onClick={scrollToOferta} className="mb-6" data-id="element-146">
              QUIERO ACCEDER AHORA <ChevronRight className="w-6 h-6" data-id="element-147" />
            </Button>
          </FadeIn>

          {/* Trust icons row */}
          <FadeIn delay={0.6} data-id="element-148">
            <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-3 max-w-3xl mx-auto" data-id="element-149">
              {trustItems.map((item, idx) => <li key={idx} className="flex items-center gap-1.5 text-sm font-medium text-gray-200" data-id="element-150">
                  <item.icon className="w-4 h-4 text-celeste flex-shrink-0" data-id="element-151" />
                  <span data-id="element-152">{item.label}</span>
                </li>)}
            </ul>
          </FadeIn>
        </div>
      </div>
    </section>;
}